// extracted by mini-css-extract-plugin
export default {"label":"PhoneInput_label__UcvW1","wrapper":"PhoneInput_wrapper__ce+Cg"};